import { createFileRoute, redirect } from '@tanstack/react-router'
import { useDeeplinks } from '../../../../../route'

export const Route = createFileRoute(
  '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { setId, questionId } = Route.useParams()
  const { defaultOrg } = useDeeplinks()
  throw redirect({
    to: `/app/organizations/${defaultOrg.id}/sets/${setId}/questions/${questionId}`,
  })
}
